import { Sso } from '@tribeplatform/gql-client/types'
import { useDomain } from '@tribeplatform/react-components/common/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { SvgSocialIcon } from '@tribeplatform/react-ui-kit/Icon'

import { AuthOperationType } from '../../../../server/middlewares/ssos/utils/sso.utils.js'
import { SsoIcon } from '../components/SsoIcons.js'
import {
  AUTH_TYPE_FORM_KEY,
  INVITE_LINK_ID_FORM_KEY,
  INVITE_TOKEN_FORM_KEY,
  PROVIDER_TYPE_FORM_KEY,
  REDIRECT_PATH_FORM_KEY,
  SSO_AUTH_TYPE,
} from '../constants.js'

type SsoAuthFormProps = {
  ssoProvider: Sso
  operationType?: AuthOperationType
  redirectPath?: string
  invitation?: {
    linkId: string
    token: string
  }
}

export const SsoAuthForm = ({
  ssoProvider: { type, buttonText, name },
  redirectPath,
  invitation,
  operationType = AuthOperationType.login,
}: SsoAuthFormProps) => {
  const { getResourceUrl } = useDomain()
  return (
    <form
      method="post"
      action={getResourceUrl(`/api/auth/${operationType}`)}
      className="space-y-5"
    >
      <input
        name={REDIRECT_PATH_FORM_KEY}
        value={redirectPath}
        hidden
        readOnly
      />
      <input name={AUTH_TYPE_FORM_KEY} value={SSO_AUTH_TYPE} hidden readOnly />
      <input name={PROVIDER_TYPE_FORM_KEY} value={type} hidden readOnly />
      {invitation && (
        <>
          <input
            name={INVITE_LINK_ID_FORM_KEY}
            value={invitation.linkId}
            hidden
            readOnly
          />
          <input
            name={INVITE_TOKEN_FORM_KEY}
            value={invitation.token}
            hidden
            readOnly
          />
        </>
      )}
      <Button
        type="submit"
        className="w-full justify-center"
        variant="secondaryNeutral"
        size="lg"
        leadingIcon={
          SsoIcon[type] && (
            <SvgSocialIcon name={SsoIcon[type]} className="me-0" rounded />
          )
        }
      >
        {buttonText || name}
      </Button>
    </form>
  )
}
